import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import projectService from '../services/projectService';
import { queryKeys } from './queryKeys';

export function useProjects(options = {}) {
  return useQuery({
    queryKey: queryKeys.projects.all,
    queryFn: () => projectService.getProjects(),
    staleTime: Infinity,
    ...options,
  });
}

export function useCreateProject(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload => projectService.createProject(payload),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}

export function useDeleteProject(options = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: projectId => projectService.deleteProject(projectId),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.projects.all });
      options.onSuccess?.(...args);
    },
    onError: options.onError,
  });
}
